import { FC } from "react";
import PopupModal from "../../../UI/Popup";

interface ViewShiftNotesProps {
  showShiftNotesModal: boolean;
  onClickClose: () => void;
  notes: string;
}

const ViewShiftNotes: FC<ViewShiftNotesProps> = ({
  showShiftNotesModal,
  onClickClose,
  notes
}) => {
    return (
        <>
            <PopupModal
                visible={showShiftNotesModal}
                showCloseBtn={true}
                onClickClose={onClickClose}
                customWidth={650}
            >
                <div className="d-flex flex-column gap-15">
                    <div className="fs-22 fw-400 text-black">Notes:</div>
                    {notes}
                </div>
            </PopupModal>
        </>
    );
};

export default ViewShiftNotes;
